import { Fragment } from 'react';
import { useTheme, LINE_HEIGHT } from '@shopify/polaris-viz-core';
import { useBrowserCheck } from '../../../../hooks/useBrowserCheck.js';
import { PILL_HEIGHT, PILL_PADDING } from '../../constants.js';
import styles from './AnnotationLabel.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SingleTextLine } from '../../../Labels/SingleTextLine.js';

const PX_OFFSET = 1;
const CONTENT_LINE_OFFSET = 3;
function AnnotationLabel({
  ariaLabel,
  hasContent,
  index,
  isVisible,
  label,
  position,
  setActiveIndex,
  tabIndex
}) {
  const selectedTheme = useTheme();
  const {
    isFirefox
  } = useBrowserCheck();
  const {
    x,
    y,
    width
  } = position;
  const formattedAriaLabel = `${ariaLabel}: ${label}`;
  return /*#__PURE__*/jsxs("g", {
    transform: `translate(${x},${y})`,
    opacity: isVisible ? 1 : 0,
    "aria-hidden": true,
    children: [/*#__PURE__*/jsx("foreignObject", {
      height: PILL_HEIGHT,
      width: width,
      style: {
        overflow: 'visible'
      },
      children: /*#__PURE__*/jsx("div", {
        className: styles.Blur,
        style: {
          borderRadius: PILL_HEIGHT / 2
        }
      })
    }), /*#__PURE__*/jsx("rect", {
      height: PILL_HEIGHT,
      width: width,
      fill: selectedTheme.annotations.backgroundColor,
      ry: PILL_HEIGHT / 2,
      opacity: isFirefox ? 1 : selectedTheme.annotations.pillOpacity
    }), /*#__PURE__*/jsx(SingleTextLine, {
      ariaHidden: true,
      color: selectedTheme.annotations.textColor,
      text: label,
      targetWidth: width - PILL_PADDING * 2 + PX_OFFSET,
      y: PILL_HEIGHT - LINE_HEIGHT - PX_OFFSET,
      x: PILL_PADDING
    }), /*#__PURE__*/jsxs(Fragment, {
      children: [hasContent && /*#__PURE__*/jsx("line", {
        x1: PILL_PADDING,
        x2: width - PILL_PADDING,
        y1: PILL_HEIGHT - CONTENT_LINE_OFFSET,
        y2: PILL_HEIGHT - CONTENT_LINE_OFFSET,
        stroke: selectedTheme.annotations.textColor,
        strokeDasharray: "1, 3",
        strokeWidth: 1
      }), /*#__PURE__*/jsx("foreignObject", {
        height: PILL_HEIGHT,
        width: width,
        style: {
          overflow: 'visible'
        },
        children: /*#__PURE__*/jsx("button", {
          "aria-describedby": `annotation-content-${index}`,
          "aria-label": formattedAriaLabel,
          className: styles.Button,
          onMouseEnter: () => setActiveIndex(index),
          onFocus: () => setActiveIndex(index),
          tabIndex: tabIndex,
          style: {
            borderRadius: PILL_HEIGHT / 2
          },
          children: label
        })
      })]
    })]
  });
}

export { AnnotationLabel };
